<template>
  <a-modal v-model="showModal" class="modalContainer infoModal" :footer="null" :closable="false">
    <h5 class="fw700 gray700 mb-2">Your Profile is {{ completedPercentage == 100 ? completedPercentage : `only ${completedPercentage}` }}% complete</h5>
    <a-progress :percent="completedPercentage" :show-info="false" :strokeColor="getPrimaryColor()" :format="percent => `${percent}%`" />
    <p class="gray500 font16 mt-2">Your profile is {{ completedPercentage }}% complete. Statistics show that people interact more with fully completed profiles.</p>
    <!-- <p class="gray500 font16 mt-2">Statistics show that people interact more with profiles completed to at least 70%.</p> -->
    <h6 class="gray700 fw700 mt-4 px-2">Complete your profile</h6>
    <SimpleLoader v-if="loading" :name="'profile completeness data'" class="mx-auto" />
    <div class="d-flex flex-column mb-4 detailsContainer">
      <div class="p-2 gray700 font16 eachDetail text-capitalize d-flex align-items-center" v-for="detail in userDetails" :key="detail.name">
        <font-awesome-icon v-if="detail.done" class="mr10 font20 success500" :icon="['fas', 'check-circle']" />
        {{ detail.display_name }} - {{ detail.value }}%
      </div>
    </div>
    <button class="rounded w-100 btn flex-center-center btn-one" @click="showProfile" :style="{ background: getPrimaryColor() }">
      <a-icon type="edit" theme="filled" />
      Edit Profile
    </button>
    <button class="rounded w-100 btn btn-two" @click="handleCancel">Continue without updating</button>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { mapGetters } from "vuex"
import SimpleLoader from "../../commons/SimpleLoader.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  components: { SimpleLoader },
  data() {
    return {
      loading: false,
      showModal: false,
      completedPercentage: 0,
      userDetails: null,
      advocateOptions: [
        { key_name: "file_name", display_name: "Upload a profile image", value: "20", done: false },
        { key_name: "circle", display_name: "Add people to your circle", value: "20", done: false },
        { key_name: "display_name", display_name: "Display Name", value: "20", done: false },
        { key_name: "location", display_name: "Location", value: "10", done: false },
        { key_name: "dob", display_name: "Birthday", value: "10", done: false },
        { key_name: "gender", display_name: "Gender", value: "10", done: false },
        { key_name: "first_post", display_name: "Create your first post", value: "10", done: false },
        // { key_name: "represent_organization", display_name: "Represent Organization", value: "10", done: false },
      ],
    }
  },
  created() {
    // if (!(this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver" || this.authUser.user.role === "advocate")) {
    //   return
    // }
    // this.fetchProfileCompleteness()
  },
  computed: {
    ...mapGetters({ circleDiseaseTypes: "Circle/circleDiseaseTypes" }),
  },
  methods: {
    show() {
      if (!(this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver" || this.authUser.user.role === "advocate")) {
        return
      }
      this.fetchProfileCompleteness()
      this.showModal = true
    },
    handleCancel() {
      this.showModal = false
      if (this.authUser.user.role === "advocate") {
        this.$store.commit("Posts/setPercent", true)
      }
    },
    async fetchProfileCompleteness() {
      if (!(this.authUser.user.role === "patient" || this.authUser.user.role === "caregiver" || this.authUser.user.role === "advocate")) {
        return
      }
      try {
        this.loading = true

        const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
        if (this.authUser.user.role === "advocate") {
          this.userDetails = this.advocateOptions.map(data => {
            if (data.key_name === "circle") {
              return { ...data, done: !!this.authUser.user.no_of_members }
            } else if (data.key_name === "file_name") {
              return { ...data, done: !!this.authUser.user.url }
            } else if (["gender", "display_name", "location"].includes(data.key_name)) {
              return { ...data, done: true }
            } else if (data.key_name === "represent_organization") {
              return { ...data, done: !!this.authUser.user.represent_organization }
            } else if (data.key_name === "dob") {
              return { ...data, done: !!(this.authUser.user.dob || this.profileData.dob) }
            } else if (data.key_name === "first_post") {
              return { ...data, done: !!this.authUser.user.first_post }
            } else {
              return { ...data, done: false }
            }
          })

          const advRes = await this.$http.get(`${process.env.BASE_API_URL}/advocateprofilecompletion/?circle_id=${this.currentCircle.id}`, { headers })
          this.completedPercentage = advRes.data.message || 0
          this.loading = false

          return
        }
        UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
          .then(aboutRes => {
            this.$http
              .get(`${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "normaluser" : "caregiver"}profilecompletion/?circle_id=${this.currentCircle.id}`, { headers })
              .then(res => {
                this.completedPercentage = res.data.message
                this.userDetails = res.data.data.filter(option => option.key_name !== "disease_type") || []
                this.userDetails = res.data.data.map(data => {
                  if (data.key_name === "circle") {
                    return { ...data, done: !!this.authUser.user.no_of_members }
                  } else if (data.key_name === "file_name") {
                    return { ...data, done: !!this.authUser.user.url }
                  } else if (["gender", "display_name", "location"].includes(data.key_name)) {
                    return { ...data, done: true }
                  } else if (data.key_name === "disease_type") {
                    return { ...data, done: aboutRes.data.data[0].disease_type }
                    // return { ...data, done: aboutRes.data.data[0].disease_type || !this.circleDiseaseTypes.length }
                  } else if (Array.isArray(aboutRes.data.data[0][data.key_name])) {
                    return { ...data, done: !!aboutRes.data.data[0][data.key_name].length }
                  } else {
                    return { ...data, done: !!aboutRes.data.data[0][data.key_name] }
                  }
                })
                this.loading = false
              })
              .catch(e => {
                this.loading = false
              })
          })
          .catch(e => {
            this.loading = false
          })
      } catch (e) {
        this.loading = false
      }
    },
    showProfile() {
      if (this.authUser.user.role === "advocate") {
        this.$store.commit("Posts/setPercent", true)
      }
      this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${this.authUser.user.role}/about` })
      return
      const profileType = this.authUser.user.role

      switch (profileType) {
        case "patient":
          this.$router.push({ name: "PatientUpdates" })
          break
        case "caregiver":
          this.$router.push({ name: "CaregiverUpdates" })
          break
        case "advocate":
          this.$router.push({ name: "AdvocateUpdates" })
          break
        case "hospital_administrator":
          this.$router.push({ name: "HosUpdates" })
          break
        case "clinic_administrator":
          this.$router.push({ name: "ClinicUpdates" })
          break
        case "doctor":
          this.$router.push({ name: "DocUpdates" })
          break
        case "hcp":
          this.$router.push({ name: "HcpAbout" })
          break
        case "nfp_administrator":
          this.$router.push({ name: "NFPAbout" })
          break
        case "clinic_profile":
          this.$router.push({ name: "Clinic_Profile" })
          break
        default:
          this.$router.push({ path: `profile/${profileType}/updates` })
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modalContainer {
  width: 400px !important;
}
.btn {
  padding: 12px 24px;
  margin-top: 24px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.btn-one {
  color: #ffffff !important;
}
.btn-two {
  background: #e2e8f0;
  color: #47556e !important;
}
.eachDetail:nth-child(even) {
  background: #f1f5f9 !important;
}
.detailsContainer {
  height: 200px;
  overflow-x: auto;
}

::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #e2e8f0;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #2a71d4;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/activity/Info.vue